var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "modal-body", attrs: { id: "new_company_id" } },
        [
          _c(
            "div",
            {
              staticClass: "m-scrollable",
              attrs: {
                "data-scrollbar-shown": "true",
                "data-scrollable": "true",
                "data-max-height": "400"
              }
            },
            [
              _c(
                "form",
                { staticClass: "m-form m-form--state", attrs: { action: "" } },
                [
                  _c("div", { staticClass: "m-portlet__body" }, [
                    _c("div", { staticClass: "form-group m-form__group row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("name") }
                        },
                        [
                          _c("label", { attrs: { for: "name" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("name")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.name,
                                expression: "company.name"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:2|max:70",
                                expression: "'required|min:2|max:70'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              type: "text",
                              id: "name",
                              name: "name",
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_name_company")
                              )
                            },
                            domProps: { value: _vm.company.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("name"),
                                  expression: "errors.has('name')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("name")) + " "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("nit") }
                        },
                        [
                          _c("label", { attrs: { for: "nit" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(_vm._f("translate")("nit"))
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.nit,
                                expression: "company.nit"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:2|max:70",
                                expression: "'required|min:2|max:70'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              type: "text",
                              id: "nit",
                              name: "nit",
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_nit_company")
                              )
                            },
                            domProps: { value: _vm.company.nit },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "nit",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("nit"),
                                  expression: "errors.has('nit')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("nit")) + " "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group m-form__group row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("type") }
                        },
                        [
                          _c("label", { attrs: { for: "type" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("type_company")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.company_type_id,
                                  expression: "company.company_type_id"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "form-control m-bootstrap-select m_selectpicker",
                              attrs: {
                                name: "type",
                                id: "type",
                                title: _vm._f("capitalize")(
                                  _vm._f("translate")("select_type_company")
                                )
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.company,
                                    "company_type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.types, function(company_type) {
                              return _c(
                                "option",
                                {
                                  key: company_type.id,
                                  domProps: { value: company_type.id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(company_type.name)
                                      )
                                    )
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("type"),
                                  expression: "errors.has('type')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("type")) + " "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("description") }
                        },
                        [
                          _c("label", { attrs: { for: "description" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("description")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.description,
                                expression: "company.description"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:2|max:70",
                                expression: "'required|min:2|max:70'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              type: "text",
                              id: "description",
                              name: "description",
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_desc_company")
                              )
                            },
                            domProps: { value: _vm.company.description },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "description",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("description"),
                                  expression: "errors.has('description')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("description")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group m-form__group row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("address") }
                        },
                        [
                          _c("label", { attrs: { for: "address" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("address")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.address,
                                expression: "company.address"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:2|max:70",
                                expression: "'required|min:2|max:70'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              type: "text",
                              id: "address",
                              name: "address",
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_dir_company")
                              )
                            },
                            domProps: { value: _vm.company.address },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "address",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("address"),
                                  expression: "errors.has('address')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("address")) + " "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6",
                          class: { "has-danger": _vm.errors.has("phone") }
                        },
                        [
                          _c("label", { attrs: { for: "phone" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("phone")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.phone,
                                expression: "company.phone"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric|min:2|max:70",
                                expression: "'required|numeric|min:2|max:70'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              type: "text",
                              id: "phone",
                              name: "phone",
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_tel_company")
                              )
                            },
                            domProps: { value: _vm.company.phone },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "phone",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("phone"),
                                  expression: "errors.has('phone')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("phone")) + " "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group m-form__group row",
                        class: {
                          "has-danger": _vm.errors.has("control_points")
                        }
                      },
                      [
                        _c("div", { staticClass: "col-lg-10" }, [
                          _c("label", { attrs: { for: "control_point" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("control_points")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.control_points,
                                  expression: "company.control_points"
                                }
                              ],
                              staticClass:
                                "form-control m-bootstrap-select m_selectpicker",
                              attrs: {
                                name: "control_points",
                                id: "control_points",
                                multiple: "",
                                title: _vm._f("capitalize")(
                                  _vm._f("translate")("select_control_points")
                                )
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.company,
                                    "control_points",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.control_points, function(control_point) {
                              return _c(
                                "option",
                                {
                                  key: control_point.id,
                                  domProps: { value: control_point.id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(control_point.name)
                                      )
                                    )
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("control_points"),
                                  expression: "errors.has('control_points')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("control_points")) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-2 pb-2",
                            attrs: { id: "car-button-container" }
                          },
                          [
                            _c("label", [_vm._v(" ")]),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-backdrop": "static",
                                  "data-keyboard": "false",
                                  "data-target": "#add_cars_modal"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showModals()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-car" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-notification" },
                                  [_vm._v(_vm._s(_vm.vehicles.length))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group m-form__group row" }, [
                      _c("div", { staticClass: "col-lg-8" }, [
                        _c("label", { staticClass: "m-checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.change_pass,
                                expression: "company.change_pass"
                              }
                            ],
                            attrs: { id: "change_pass", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.company.change_pass)
                                ? _vm._i(_vm.company.change_pass, null) > -1
                                : _vm.company.change_pass
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.company.change_pass,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.company,
                                          "change_pass",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.company,
                                          "change_pass",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.company, "change_pass", $$c)
                                  }
                                },
                                _vm.changePass
                              ]
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("change_pass")
                                )
                              ) +
                              "\n                "
                          ),
                          _c("span")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-4",
                          class: { "has-dangerr": _vm.errors.has("days") }
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.days_change_pass,
                                  expression: "company.days_change_pass"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.company.change_pass
                                    ? "required|numeric|max:3"
                                    : "",
                                  expression:
                                    "company.change_pass ? 'required|numeric|max:3' : ''"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                type: "text",
                                disabled: _vm.company.change_pass
                                  ? false
                                  : true,
                                name: "days"
                              },
                              domProps: { value: _vm.company.days_change_pass },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.company,
                                    "days_change_pass",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("days")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("days"),
                                  expression: "errors.has('days')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("days")) + " "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group m-form__group" }, [
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.company.company_test,
                              expression: "company.company_test"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.company.company_test)
                              ? _vm._i(_vm.company.company_test, null) > -1
                              : _vm.company.company_test
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.company.company_test,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.company,
                                      "company_test",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.company,
                                      "company_test",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.company, "company_test", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("company_test")
                              )
                            ) +
                            "\n              "
                        ),
                        _c("span")
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              id: "btn-cancel"
            },
            on: { click: _vm.resetForm }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.submitForm }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_cars_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("vehicles")),
            close_header: true,
            size: "modal-sm modal-dialog-centered",
            close_modal: true
          },
          on: {
            close: function($event) {
              return _vm.close("container_cars")
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "true",
                    "data-scrollable": "true",
                    "data-max-height": "200"
                  }
                },
                [
                  _c("form", { attrs: { "data-vv-scope": "container_cars" } }, [
                    _c(
                      "div",
                      { staticClass: "form-group m-form__group" },
                      _vm._l(_vm.vehicles, function(car, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "row space-down card-container"
                          },
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  {
                                    "has-danger": _vm.errors.has(
                                      "container_cars.plate" + idx
                                    )
                                  },
                                  "col-lg-9"
                                ]
                              },
                              [
                                _c("label", { attrs: { for: "plate" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("plate")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: car.license_plate,
                                      expression: "car.license_plate"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "form-control m-input",
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: {
                                    type: "text",
                                    id: "plate",
                                    name: "plate" + idx,
                                    placeholder: "enter plate"
                                  },
                                  domProps: { value: car.license_plate },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        car,
                                        "license_plate",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "container_cars.plate" + idx
                                        ),
                                        expression:
                                          "errors.has(`container_cars.plate${idx}`)"
                                      }
                                    ],
                                    staticClass: "m-form__help m--font-danger"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "container_cars.plate" + idx
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-lg-3" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(" ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.deleteVehicle(idx)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.addCar.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30f3cbd4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f3cbd4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/company/New.vue
// module id = 447
// module chunks = 0 1 66 143